<template>
  <div
    class="d-flex flex-column gr-10 text--text"
  >
    <div :class="isMobile ? 'text-h6 text-center' : 'text-h5'">
      {{ t('Зачем регистрироваться', options) }}
    </div>

    <div
      class="benefits-of-registration-list ga-10"
    >
      <div class="d-flex flex-column gr-4 flex-grow-1">
        <div class="ui-icon-reviews-40 ui-icon_type_40 brand" />
        <div class="text-subtitle-1">
          {{ t('Отзывы пациентов', options) }}
        </div>
        <div class="text-body-2 text-secondary--text">
          — {{ t('Уведомления о новых отзывах', options) }}
          <br>— {{ t('Приватный чат с автором', options) }}
          <br>— {{ t('Публикация ответов', options) }}
        </div>
      </div>

      <div class="d-flex flex-column gr-4 flex-grow-1">
        <div class="ui-icon-doc-40 ui-icon_type_40 warning" />
        <div class="text-subtitle-1">
          {{ t('Профиль врача', options) }}
        </div>
        <div class="text-body-2 text-secondary--text">
          — {{ t('Актуализация информации', options) }}
          <br>— {{ t('Публикация дополнительных сведений', options) }}
          <br>— {{ t('Фотогалерея', options) }}
        </div>
      </div>

      <div class="d-flex flex-column gr-4 flex-grow-1">
        <div class="ui-icon-megaphone-40 ui-icon_type_40 secondary" />
        <div class="text-subtitle-1">
          {{ t('Привлечение пациентов', options) }}
        </div>
        <div class="text-body-2 text-secondary--text">
          — {{ t('Формирование бренда врача', options) }}
          <br>— {{ t('Публикация ответов на вопросы пациентов', options) }}
          <br>— {{ t('Написание статей о болезнях', options) }}
        </div>
      </div>

      <div
        v-if="context.request.country.is_russia"
        class="d-flex flex-column gr-4 flex-grow-1"
      >
        <div class="ui-icon-computer-40 ui-icon_type_40 success" />
        <div class="text-subtitle-1">
          {{ t('«Профи» в подарок на год!', options) }}
        </div>
        <div class="text-body-2 text-secondary--text">
          — {{ t('Отсутствие рекламы на странице доктора', options) }}
          <br>— {{ t('Отсутствие раздела «популярные врачи в городе»', options) }}
          <br>— {{ t('Сбор и визуализация аналитики', options) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import type { ContextStore } from 'src/components/pages/profile/doctors/register/index/types'
import useContextStore from 'src/store/useContextStore'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')
</script>

<style lang="scss" scoped>
.benefits-of-registration-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(226px, 1fr));

  @media (max-width: 789.98px) {
    text-align: center;

    & > * {
      align-items: center;
    }
  }
}
</style>
